import React from 'react';

export const PageNotFound = () => (
    <div>
        Sorry old sport, page is not found :(
    </div>
)
